/**
 * @typedef RewardItem
 * @property {Fixed8} reward - the MODC value of getting reward.
 * @property {string} fileContractHash - The hash of File Contract.
 */
export const RewardItem = (rewardItem = {}) => {
  return {
    fileContractHash: rewardItem.fileContractHash || ''
  }
}

export const exportRewardItem = rewardItem => {
  return {
    fileContractHash: rewardItem.fileContractHash
  }
}
